module.exports = __webpack_public_path__ + "img/certified_advisory.274ca23d.png";